import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=57b64b5c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=57b64b5c&prod&lang=scss&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=57b64b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b64b5c",
  null
  
)

export default component.exports